<template>
    <router-view/>
</template>

<style>
  @import url('https://fonts.googleapis.com/css?family=Concert+One&display=swap');
</style>
